import { sendPost } from '../http.js'
export default  {
   courseList(params){ //添加套餐
       return sendPost('/user/user/onlineproduct/productlist',params)
    },
    changeStatus(params){ //添加套餐
        return sendPost('/user/user/onlineproduct/productupdate',params)
     },      
   
}